import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import CommandPalette from "@/components/CommandPalette";
import AuthCallback from "@/components/AuthCallback";
import ChooserPage from "@/pages/ChooserPage";
import LoginPage from "@/pages/LoginPage";
import BoardPage from "@/pages/BoardPage";
import ClientsListPage from "@/pages/ClientsListPage";
import MyDayPage from "@/pages/MyDayPage";
import ArchivedPage from "@/pages/ArchivedPage";
import ActivityPage from "@/pages/ActivityPage";
import StuckPage from "@/pages/StuckPage";
import OverduePage from "@/pages/OverduePage";
import CalendarPage from "@/pages/CalendarPage";
import InboxPage from "@/pages/InboxPage";
import RnVisitPage from "@/pages/RnVisitPage";
import FieldAgentHome from "@/pages/FieldAgentHome";
import ReportsPage from "@/pages/ReportsPage";
import SettingsPage from "@/pages/SettingsPage";
import PartnersPage from "@/pages/PartnersPage";
import OutreachPage from "@/pages/OutreachPage";
import ProspectsPage from "@/pages/ProspectsPage";
import PcwsPage from "@/pages/PcwsPage";
import CompliancePage from "@/pages/CompliancePage";
import SecurityPage from "@/pages/SecurityPage";
import LoginBriefingGate from "@/components/LoginBriefingGate";

function AppRoutes() {
  const location = useLocation();
  // Detect Google OAuth return synchronously during render (session_id in URL fragment)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/choose" element={<ProtectedRoute><ChooserPage /></ProtectedRoute>} />
      <Route path="/" element={<ProtectedRoute><BoardPage /></ProtectedRoute>} />
      <Route path="/clients" element={<ProtectedRoute><ClientsListPage /></ProtectedRoute>} />
      <Route path="/my-day" element={<ProtectedRoute><MyDayPage /></ProtectedRoute>} />
      <Route path="/inbox" element={<ProtectedRoute><InboxPage /></ProtectedRoute>} />
      <Route path="/calendar" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
      <Route path="/rn/:cardId" element={<ProtectedRoute><RnVisitPage /></ProtectedRoute>} />
      <Route path="/field" element={<ProtectedRoute fieldAgentHome><FieldAgentHome /></ProtectedRoute>} />
      <Route path="/archived" element={<ProtectedRoute><ArchivedPage /></ProtectedRoute>} />
      <Route path="/stuck" element={<ProtectedRoute><StuckPage /></ProtectedRoute>} />
      <Route path="/overdue" element={<ProtectedRoute><OverduePage /></ProtectedRoute>} />
      <Route path="/activity" element={<ProtectedRoute><ActivityPage /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
      <Route path="/partners" element={<ProtectedRoute><PartnersPage /></ProtectedRoute>} />
      <Route path="/outreach" element={<ProtectedRoute><OutreachPage /></ProtectedRoute>} />
      <Route path="/prospects" element={<ProtectedRoute><ProspectsPage /></ProtectedRoute>} />
      <Route path="/pcws" element={<ProtectedRoute><PcwsPage /></ProtectedRoute>} />
      <Route path="/compliance" element={<ProtectedRoute><CompliancePage /></ProtectedRoute>} />
      <Route path="/security" element={<ProtectedRoute><SecurityPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute adminOnly><SettingsPage /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors offset="76px" />
        <CommandPalette />
        <AppRoutes />
        <LoginBriefingGate />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
